// Stub Chat partials
import React from "react";

export const ChatItemHeader: React.FC<{ item?: any }> = ({ item }) => {
  return <div className="chat-item-header">{item?.name || "Chat"}</div>;
};

export default ChatItemHeader;
